export const routesList = [
  {
    path: "/",
    redirect: "/Customer/Home",
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登录" },
    component: () => import("@/view/login/index.vue"),
  },
  {
    path: "/Home",
    name: "Home",
    meta: { title: "管理员首页" },
    component: () => import("@/view/Home/Home.vue"),
  },
  {
    path: "/Customer/Home",
    name: "CusHome",
    meta: { title: "客户首页" },
    component: () => import("@/view/Home/Customer/Home.vue"),
  },

  {
    path: "/Customer/ProductCenter",
    name: "CusProductCenter",
    meta: { title: "客户现货产品中心" },
    component: () => import("@/view/ProductCenter/Customer/ProductCenter.vue"),
  },
  {
    path: "/Customer/Set",
    name: "CusSet",
    meta: { title: "客户设置" },
    component: () => import("@/view/Set/Customer/Set.vue"),
  },
  {
    path: "/AddOrder",
    name: "AddOrder",
    meta: { title: "添加订单" },
    component: () => import("@/view/AddOrder/index.vue"),
  },
  {
    path: "/GroupCustomization",
    name: "GroupCustomization",
    meta: { title: "添加订单", keepAlive: true },
    component: () => import("@/view/AddOrder/GroupCustomization.vue"),
  },
  {
    path: "/PaymentCode",
    name: "PaymentCode",
    meta: { title: "收款码" },
    component: () => import("@/view/PaymentCode/PaymentCode.vue"),
  },
  {
    path: "/OrderInfo",
    name: "OrderInfo",
    meta: { title: "订单信息", keepAlive: true },
    component: () => import("@/view/OrderInfo/OrderInfo.vue"),
  },
  {
    path: "/VolumInfo",
    name: "VolumInfo",
    meta: { title: "量体信息" },
    component: () => import("@/view/OrderInfo/VolumInfo.vue"),
  },
  {
    path: "/Set",
    name: "Set",
    meta: { title: "管理员设置" },
    component: () => import("@/view/Set/Set.vue"),
  },
  {
    path: "/DesignCenter",
    name: "DesignCenter",
    meta: { title: "设计中心" },
    component: () => import("@/view/DesignCenter/DesignCenter.vue"),
  },
  {
    path: "/Customer/DesignCenter",
    name: "CustomerDesignCenter",
    meta: { title: "设计中心" },
    component: () => import("@/view/DesignCenter/DesignCenter.vue"),
  },
  {
    path: "/ProductCenter",
    name: "ProductCenter",
    meta: { title: "产品中心" },
    component: () => import("@/view/ProductCenter/ProductCenter.vue"),
  },
  {
    path: "/ProductList",
    name: "ProductList",
    component: () => import("@/view/ProductCenter/ProductList.vue"),
  },
  {
    path: "/Matching",
    name: "Matching",
    meta: { title: "同款搭配" },
    component: () => import("@/view/ProductCenter/Matching.vue"),
  },
  {
    path: "/ProductInfo",
    name: "ProductInfo",
    meta: { title: "商品规格信息" },
    component: () => import("@/view/ProductCenter/Info.vue"),
  },
  {
    path: "/ProductEdit",
    name: "Edit",
    meta: { title: "商品信息修改" },
    component: () => import("@/view/ProductCenter/InfoEntry.vue"),
  },
  {
    path: "/SpecInfo/:id",
    name: "SpecInfo",
    meta: { title: "商品规格信息" },
    component: () => import("@/view/ProductCenter/SpecInfo.vue"),
  },
  {
    path: "/SpecInfo/Inventory/:goodsId/:id",
    name: "Inventory",
    meta: { title: "商品规格库存信息" },
    component: () => import("@/view/ProductCenter/Inventory.vue"),
  },
  {
    path: "/Category",
    name: "Category",
    meta: { title: "商品分类" },
    component: () => import("@/view/ProductCenter/Category.vue"),
  },
  {
    path: "/CategoryChilren",
    name: "CategoryChilren",
    meta: { title: "商品子分类" },
    component: () => import("@/view/ProductCenter/CategoryChilren.vue"),
  },
  {
    path: "/InboundAndOutbound",
    name: "InboundAndOutbound",
    meta: { title: "商品出入库" },
    component: () => import("@/view/ProductCenter/InboundAndOutbound.vue"),
  },
  {
    path: "/ClassificationList",
    name: "ClassificationList",
    meta: { title: "面料列表" },
    component: () => import("@/view/ProductCenter/ClassificationList.vue"),
  },
  {
    path: "/Classificamanage",
    name: "Classificamanage",
    meta: { title: "分类管理" },
    component: () => import("@/view/ProductCenter/Classificamanage.vue"),
  },
  {
    path: "/AddFabric/:id?",
    name: "AddFabric",
    meta: { title: "添加面料" },
    component: () => import("@/view/ProductCenter/AddFabric.vue"),
  },

  {
    path: "/CompanyStandardDataCable",
    name: "CompanyStandardDataCable",
    meta: { title: "企业标准数据库" },
    component: () => import("@/view/Home/CompanyStandardDataCable.vue"),
  },
  {
    path: "/StandardDataCable",
    name: "StandardDataCable",
    meta: { title: "标准数据库" },
    component: () => import("@/view/Home/StandardDataCable.vue"),
  },
  {
    path: "/systemStandarData",
    name: "systemStandarData",
    meta: { title: "系统标准数据库" },
    component: () => import("@/view/Home/systemStandarData.vue"),
  },
  {
    path: "/volumeDataCable",
    name: "volumeDataCable",
    meta: { title: "量体数据库" },
    component: () => import("@/view/Home/volumeDataCable.vue"),
  },
  {
    path: "/CompanyTable",
    name: "CompanyTable",
    meta: { title: "标准数据库-企业信息" },
    component: () => import("@/view/Home/companyTable.vue"),
  },
  {
    path: "/AddCompany",
    name: "AddCompany",
    meta: { title: "新增企业信息" },
    component: () => import("@/view/Home/addCompany.vue"),
  },
  {
    path: "/AddCompany",
    name: "AddCompany",
    meta: { title: "编辑企业信息" },
    component: () => import("@/view/Home/addCompany.vue"),
  },
  {
    path: "/AddCategory",
    name: "AddCategory",
    meta: { title: "添加自定义量体参数" },
    component: () => import("@/view/Home/addCategory.vue"),
  },
  {
    path: "/Inbound",
    name: "Inbound",
    meta: { title: "商品入库" },
    component: () => import("@/view/ProductCenter/Inbound.vue"),
  },
  {
    path: "/Outbound",
    name: "Outbound",
    meta: { title: "商品出库" },
    component: () => import("@/view/ProductCenter/Outbound.vue"),
  },
  {
    path: "/InboundOutboundRecords",
    name: "InboundOutboundRecords",
    meta: { title: "出入库记录" },
    component: () => import("@/view/ProductCenter/InboundOutboundRecords.vue"),
  },
  {
    path: "/InfoEntry",
    name: "InfoEntry",
    meta: { title: "商品信息录入" },
    component: () => import("@/view/ProductCenter/InfoEntry.vue"),
  },
  {
    path: "/orderDetails",
    name: "orderDetails",
    meta: { title: "订单详情" },
    component: () => import("@/view/Home/orderDetails.vue"),
  },
  {
    path: "/ProcessComponents",
    name: "ProcessComponents",
    meta: { title: "工艺部件分类" },
    component: () => import("@/view/ProductCenter/ProcessComponents.vue"),
  },
  {
    path: "/ProcessList",
    name: "ProcessList",
    meta: { title: "工艺部件列表" },
    component: () => import("@/view/ProductCenter/ProcessList.vue"),
  },
  {
    path: "/WarehouseIndex",
    name: "WarehouseIndex",
    meta: { title: "仓库管理" },
    component: () => import("@/view/ProductCenter/WarehouseIndex.vue"),
  },
  {
    path: "/WarehouseList",
    name: "WarehouseList",
    meta: { title: "仓库列表" },
    component: () => import("@/view/ProductCenter/WarehouseList.vue"),
  },
  {
    path: "/OrderDelivery",
    name: "OrderDelivery",
    meta: { title: "订单出库" },
    component: () => import("@/view/ProductCenter/OrderDelivery.vue"),
  },
  {
    path: "/OrderShippedStock",
    name: "OrderShippedStock",
    meta: { title: "订单产品出库" },
    component: () => import("@/view/ProductCenter/OrderShippedStock.vue"),
  },
  {
    path: "/OrderShippedStockIn",
    name: "OrderShippedStockIn",
    meta: { title: "订单产品入库" },
    component: () => import("@/view/ProductCenter/OrderShippedStockIn.vue"),
  },
  {
    path: "/SpecialQuestion",
    name: "SpecialQuestion",
    meta: { title: "特殊体型列表" },
    component: () => import("@/view/ProductCenter/SpecialQuestion.vue"),
  },
  {
    path: "/Customer/CustomerPortalGroup",
    name: "CustomerPortalGroup",
    meta: { title: "编辑团体定制信息" },
    component: () => import("@/view/CustomerPortalGroup/index.vue"),
  },
  {
    path: "/Customer/CustomerPortal",
    name: "CustomerPortal",
    meta: { title: "客户入口私人定制" },
    component: () => import("@/view/CustomerPortal/CustomerPortal.vue"),
  },
  {
    path: "/Customer/CustomerPortalDetail",
    name: "CustomerPortalDetail",
    meta: { title: "客户入口私人定制量体信息详情" },
    component: () => import("@/view/CustomerPortal/CustomerPortalDetail.vue"),
  },
  {
    path: "/Customer/CustomerPortalGroupDetail",
    name: "CustomerPortalGroupDetail",
    meta: { title: "客户入口团体定制量体信息详情" },
    component: () =>
      import("@/view/CustomerPortalGroup/CustomerPortalGroupDetail.vue"),
  },
  {
    path: "/Customer/VolumeInformation",
    name: "information",
    meta: { title: "团体量体信息" },
    component: () => import("@/view/CustomerPortalGroup/VolumeInformation.vue"),
  },
  {
    path: "/Customer/EditBusinessInformation/:status?",
    name: "EditBusinessInformation",
    meta: { title: "编辑企业信息" },
    component: () =>
      import("@/view/CustomerPortalGroup/EditBusinessInformation.vue"),
  },
  {
    path: "/Customer/EditDepartment/:tid?/:id?",
    name: "EditDepartment",
    meta: { title: "编辑部门" },
    component: () => import("@/view/CustomerPortalGroup/EditDepartment.vue"),
  },
  {
    path: "/Customer/EditPortalGroup/:tid/:did/:status?",
    name: "EditPortalGroup",
    meta: { title: "编辑团体定制信息" },
    component: () => import("@/view/CustomerPortalGroup/EditPortalGroup.vue"),
  },
  {
    path: "/SupplyChainList",
    name: "SupplyChainList",
    meta: { title: "供应链分类列表" },
    component: () => import("@/view/SupplyChain/SupplyChainList.vue"),
  },
  {
    path: "/goodsList",
    name: "goodsList",
    meta: { title: "产品列表" },
    component: () => import("@/view/SupplyChain/goodsList.vue"),
  },
  {
    path: "/customerList",
    name: "CustomerList",
    meta: { title: "客户信息" },
    component: () => import("@/view/CustomerList/index.vue"),
  },
  {
    path: "/captiveProduct",
    name: "captiveProduct",
    meta: { title: "专属产品" },
    component: () => import("@/view/CustomerList/captiveProduct.vue"),
  },
  {
    path: "/accountStatement",
    name: "accountStatement",
    meta: { title: "账单" },
    component: () => import("@/view/CustomerList/accountStatement.vue"),
  },
  {
    path: "/billingDetails",
    name: "billingDetails",
    meta: { title: "账单详情" },
    component: () => import("@/view/CustomerList/billingDetails.vue"),
  },
  {
    path: "/otherExpenses",
    name: "otherExpenses",
    meta: { title: "其他费用" },
    component: () => import("@/view/CustomerList/otherExpenses.vue"),
  },
  {
    path: "/paymentRecord",
    name: "paymentRecord",
    meta: { title: "收款记录" },
    component: () => import("@/view/CustomerList/paymentRecord.vue"),
  },
  {
    path: "/newCollections",
    name: "newCollections",
    meta: { title: "新增收款" },
    component: () => import("@/view/CustomerList/newCollections.vue"),
  },
  {
    path: "/CustomerInfo",
    name: "CustomerInfo",
    meta: { title: "客户信息" },
    component: () => import("@/view/CustomerList/CustomerInfo.vue"),
  },
  {
    path: "/AddCustomer",
    name: "AddCustomer",
    meta: { title: "新增客户信息" },
    component: () => import("@/view/CustomerList/addCustomer.vue"),
  },
  {
    path: "/viewDetails",
    name: "viewDetails",
    meta: { title: "查看详情" },
    component: () => import("@/view/CustomerList/viewDetails.vue"),
  },
  {
    path: "/PreIndex",
    name: "PreIndex",
    meta: { title: "预约客户信息" },
    component: () => import("@/view/CustomerList/preIndex.vue"),
  },
  {
    path: "/OrderAccountList",
    name: "OrderAccountList",
    meta: { title: "订单账单" },
    component: () => import("@/view/OrderAccount/orderAccountList.vue"),
  },
  {
    path: "/OrderPayList",
    name: "OrderPayList",
    meta: { title: "支出" },
    component: () => import("@/view/OrderAccount/ordePayList.vue"),
  },
  {
    path: "/addExpenses",
    name: "addExpenses",
    meta: { title: "新增支出" },
    component: () => import("@/view/OrderAccount/addExpenses.vue"),
  },
  {
    path: "/addPay",
    name: "addPay",
    meta: { title: "新增收入" },
    component: () => import("@/view/OrderAccount/addPay.vue"),
  },
  {
    path: "/accountIndex",
    name: "accountIndex",
    meta: { title: "财务管理" },
    component: () => import("@/view/OrderAccount/index.vue"),
  },
  {
    path: "/SmartpPicture",
    name: "SmartpPicture",
    meta: { title: "智能画册" },
    component: () => import("@/view/SmartpPicture/index.vue"),
  },
  {
    path: "/addAlbum",
    name: "addAlbum",
    meta: { title: "新增画册" },
    component: () => import("@/view/SmartpPicture/addAlbum.vue"),
  },
  {
    path: "/likeDataCable",
    name: "likeDataCable",
    meta: { title: "喜好数据库" },
    component: () => import("@/view/Home/likeDataCable.vue"),
  },
  {
    path: "/memberCenter",
    name: "memberCenter",
    meta: { title: "会员列表" },
    component: () => import("@/view/memberCenter/index.vue"),
  },
  {
    path: "/memberLevel",
    name: "memberLevel",
    meta: { title: "会员等级列表" },
    component: () => import("@/view/memberCenter/memberLevel.vue"),
  },
  {
    path: "/MemberRecharge",
    name: "MemberRecharge",
    meta: { title: "充值管理" },
    component: () => import("@/view/memberCenter/MemberRecharge.vue"),
  },
  {
    path: "/rechargeForm",
    name: "rechargeForm",
    meta: { title: "充值管理" },
    component: () => import("@/view/memberCenter/rechargeForm.vue"),
  },
  {
    path: "/advList",
    name: "advList",
    meta: { title: "广告列表" },
    component: () => import("@/view/advManagement/advList"),
  },
  {
    path: "/addAdv",
    name: "addAdv",
    meta: { title: "编辑广告" },
    component: () => import("@/view/advManagement/addAdv"),
  },
  {
    path: "/washingCenter",
    name: "washingCenter",
    meta: { title: "干洗订单" },
    component: () => import("@/view/washingCenter/index"),
  },
  {
    path: "/addWashing",
    name: "addWashing",
    meta: { title: "干洗订单" },
    component: () => import("@/view/washingCenter/addWashing"),
  },
  {
    path: "/washingOrder",
    name: "washingOrder",
    meta: { title: "干洗订单" },
    component: () => import("@/view/washingCenter/washingOrder"),
  },
  {
    path: "/washingPay",
    name: "washingPay",
    meta: { title: "支付" },
    component: () => import("@/view/washingCenter/washingPay"),
  },
  {
    path: "/addProductType",
    name: "addProductType",
    meta: { title: "量体产品类型" },
    component: () => import("@/view/CustomerList/addProductType"),
  },
  {
    path: "/selectProductType",
    name: "selectProductType",
    meta: { title: "添加类型" },
    component: () => import("@/view/CustomerList/selectProductType"),
  },
  {
    path: "/databaseSelection",
    name: "databaseSelection",
    meta: { title: "数据库选择" },
    component: () => import("@/view/CustomerList/databaseSelection"),
  },
  {
    path: "/addEmbroider",
    name: "addEmbroider",
    meta: { title: "绣花设置" },
    component: () => import("@/view/AddOrder/addEmbroider"),
  },
  {
    path: "/setDepartment",
    name: "setDepartment",
    meta: { title: "部门设置" },
    component: () => import("@/view/AddOrder/setDepartment"),
  },
  {
    path: "/orderCaptiveProduct",
    name: "orderCaptiveProduct",
    meta: { title: "专属产品" },
    component: () => import("@/view/AddOrder/orderCaptiveProduct"),
  },
  {
    path: "/billList",
    name: "billList",
    meta: { title: "账单" },
    component: () => import("@/view/washingCenter/billList"),
  },
  {
    path: "/supplierList",
    name: "supplierList",
    meta: { title: "供应商管理" },
    component: () => import("@/view/supplierManagement/index"),
  },
  {
    path: "/addSupplier",
    name: "addSupplier",
    meta: { title: "编辑供应商" },
    component: () => import("@/view/supplierManagement/addSupplier"),
  },
  {
    path: "/supplierProduct",
    name: "supplierProduct",
    meta: { title: "编辑供应商" },
    component: () => import("@/view/supplierManagement/supplierProduct"),
  },
  {
    path: "/withdrawManage",
    name: "withdrawManage",
    meta: { title: "提现管理" },
    component: () => import("@/view/CustomerList/withdrawManage"),
  },
  {
    path: "/addWithdraw",
    name: "addWithdraw",
    meta: { title: "提现" },
    component: () => import("@/view/CustomerList/addWithdraw"),
  },
  {
    path: "/groupPerformance",
    name: "groupPerformance",
    meta: { title: "团队业绩" },
    component: () => import("@/view/CustomerList/groupPerformance"),
  },
  {
    path: "/groupMember",
    name: "groupMember",
    meta: { title: "团队成员" },
    component: () => import("@/view/CustomerList/groupMember"),
  },
  {
    path: "/cashOrderEdit",
    name: "cashOrderEdit",
    meta: { title: "订单编辑" },
    component: () => import("@/view/OrderInfo/cashOrderEdit"),
  },
  {
    path: "/addCashOrder",
    name: "addCashOrder",
    meta: { title: "订单编辑" },
    component: () => import("@/view/OrderInfo/addCashOrder"),
  },
  {
    path: "/addCoupon",
    name: "addCoupon",
    meta: { title: "编辑优惠券" },
    component: () => import("@/view/advManagement/addCoupon"),
  },
  {
    path: "/couponList",
    name: "couponList",
    meta: { title: "优惠券列表" },
    component: () => import("@/view/advManagement/couponList"),
  },
  {
    path: "/couponUseList",
    name: "couponUseList",
    meta: { title: "优惠券领取列表" },
    component: () => import("@/view/advManagement/couponUseList"),
  },
  {
    path: "/addCoupon",
    name: "addCoupon",
    meta: { title: "编辑优惠券" },
    component: () => import("@/view/advManagement/addCoupon"),
  },
  {
    path: "/couponList",
    name: "couponList",
    meta: { title: "优惠券列表" },
    component: () => import("@/view/advManagement/couponList"),
  },
  {
    path: "/couponUseList",
    name: "couponUseList",
    meta: { title: "优惠券领取列表" },
    component: () => import("@/view/advManagement/couponUseList"),
  },
  {
    path: "/designCategory",
    name: "designCategory",
    meta: { title: "款式分类" },
    component: () => import("@/view/designManage/designCategory"),
  },
  {
    path: "/categoryChild",
    name: "categoryChild",
    meta: { title: "款式子分类" },
    component: () => import("@/view/designManage/categoryChild"),
  },
  {
    path: "/designList",
    name: "designList",
    meta: { title: "款式列表" },
    component: () => import("@/view/designManage/designList"),
  },
  {
    path: "/designAdd",
    name: "designAdd",
    meta: { title: "添加款式" },
    component: () => import("@/view/designManage/designAdd"),
  },
  {
    path: "/designEdit",
    name: "designEdit",
    meta: { title: "编辑款式" },
    component: () => import("@/view/designManage/designAdd"),
  },
];
